export const COLOR_AZUL_MAIN = "#1F69AD";